import React, {useMemo} from "react";
import classNames from "classnames";
import {safeHTML} from "../../utils/safeHTML";
import Icon from "../baseComponents/gui/icon/Icon";
import {useRouter} from "next/router";
import {useDispatch} from "react-redux";
import {changeFilter} from "../../redux/reducer/panel";
import {defaultColor} from "../../constants/copyright";
import Link from "next/link";
import styles from "./PostCard.module.scss";
import Image from "next/image";
import useIsMobile from "../../hooks/useIsMobile";


const PostCard = React.forwardRef(
  function PostCard({
                      className,
                      type,
                      color,
                      tagsColor,
                      isFetchpriority,
                      picture,
                      title,
                      image,
                      tags,
                      date,
                      time,
                      author,
                      preview,
                      href,
                      onClick
                    }, ref) {
    const dispatch = useDispatch()
    const router = useRouter()
    const isMobile = useIsMobile()

    const srcSet = useMemo(() => (
      isMobile ? picture?.sourceData?.sources[0] || picture?.imgAttr : picture?.imgAttr
    ), [picture, isMobile])

    return (
      <Link legacyBehavior href={href || ''}>
        <a className={classNames(styles.postCard , className, {
         [styles[`postCard_${type}`]]: type,
         [styles[`postCard_${color}`]]: color
        })}
           style={{
             "--color": `${color && defaultColor}`
           }}
           ref={ref}>
          <div className={styles.postCard__image}>
            {(image || preview) &&
              <Image
                src={srcSet?.srcSet || srcSet?.src}
                alt={srcSet?.alt || "img"}
                width={srcSet?.width || 416}
                height={srcSet?.height || 240}
                loading={isFetchpriority ? "eager" : "lazy"}
                quality={100}
                sizes="(max-width: 1023px) 100vw, 1600px"
                priority={isFetchpriority}
              />
            }
          </div>
          <div className={styles.postCard__tags}>
            {
              tags?.map((item, index) => (
                <span className={styles.postCard__tag} key={`tag-${index}`}
                      style={{background: `${!tagsColor ? defaultColor : item.color}`}} onClick={(e) => {
                  dispatch(changeFilter(item?.href))
                  router.push(item?.href)
                  e.stopPropagation();
                }}>
                {safeHTML(item?.title)}
              </span>
              ))
            }
          </div>
          {author &&
            <div className={styles.postCard__author}>
            <span className={styles.postCard__authorAvatar}>
              <img src={author?.avatar} alt={author?.name} loading="lazy" width={48} height={48}/>
            </span>
              <span className={styles.postCard__authorName}>{safeHTML(author?.name)}</span>

            </div>
          }
          <strong className={styles.postCard__title}>{safeHTML(title)}</strong>
          {date && <div className={styles.postCard__date}>{safeHTML(date)}</div>}
          {time && <div className={styles.postCard__time}>
            <div className={styles.postCard__timeIcon}>
              <Icon name={"time"}/>
            </div>
            <span className={styles.postCard__timeText}>{time}</span>
          </div>}
        </a>
      </Link>
    );
  });
export default PostCard;
PostCard.propTypes = {};

